import { pageName, pageType } from './page-load';
import { useCountry } from '@/hooks/use-country';
import { SEARCH_RESULT_GROUP_JOIN_KEY, SEARCH_RESULT_ITEM_JOIN_KEY } from '@/app/utils/constant';

export const getNameAndType = (segments) => {
  let type = segments.join('/');
  let name = segments.join('/');
  if (segments[0] === 'search' && segments[1] === 'category') {
    type = pageType['search/category'];
    name = type + ':' + segments.pop();
  } else if (segments[0] === 'product') {
    type = pageType['product'];
    name = pageName['product'] + segments.pop();
  } else if (segments[0] === 'store' && segments[1] === 'v2') {
    if (segments[2] === 'account-center') {
      type = 'account';
      name = 'account::' + segments.join(':');
    } else {
      type = 'store';
      name = segments.join(':');
    }
  } else if (segments[2] === 'home') {
    type = 'cq';
    name = segments.slice(3).join(':');
    if (name.lastIndexOf('.htm') !== -1) {
      name = name.substring(0, name.lastIndexOf('.htm'));
    }
  } else if (segments[2] === 'home.html') {
    name = 'home';
    type = 'lthome';
  } else if (segments[0] === 'order' && segments[1] === 'dex') {
    name = 'chem dex:home';
    type = 'chemdex search';
  } else {
    let tempName = name;
    Object.keys(pageName).map((key) => {
      if (name.startsWith(key)) {
        tempName = pageName[key];
      }
    });
    name = tempName;
    let tempType = type;
    Object.keys(pageType).map((key) => {
      if (type.startsWith(key)) {
        tempType = pageType[key];
      }
    });
    type = tempType;
  }
  return { name, type };
};

export function getProductPrice(priceObj) {
  if (priceObj?.priceStatus.toLowerCase() === 'orderable') {
    if (priceObj?.bestPrice && priceObj?.listPrice)
      return priceObj.bestPrice <= priceObj.listPrice ? priceObj.bestPrice.toFixed(2) : priceObj.listPrice.toFixed(2);
    else if (priceObj?.listPrice) return priceObj.listPrice.toFixed(2);
    else if (priceObj?.bestPrice) return priceObj.bestPrice.toFixed(2);
  }
  return 0;
}

export function getPriceType(productPrice) {
  if (!productPrice || Object.keys(productPrice).length === 0) return;

  const priceType = {};

  for (const key in productPrice) {
    if (productPrice[key]) {
      const value = productPrice[key];
      let status;
      if (value.wopPrice <= value.contractPrice && value.wopPrice === value.bestPrice) {
        status = 'wopPrice';
      } else if (value.contractPrice <= value.bestPrice) {
        status = 'contractPrice';
      } else if (value.bestPrice) {
        status = 'bestPrice';
      }
      priceType[key] = status;
    }
  }

  return priceType;
}
export function searchFilterTracking(filter, refinements) {
  try {
    const params = decodeURIComponent(filter).split(SEARCH_RESULT_GROUP_JOIN_KEY);
    let filterName = '';
    params.forEach((item, index) => {
      const [name, valueString] = item.split(':');
      const filterValues = valueString?.split(SEARCH_RESULT_ITEM_JOIN_KEY);
      const category = refinements?.find((refinement) => refinement.name === name);
      if (category) {
        const displayName = category.displayName;
        const childNames = filterValues.map(
          (value) =>
            (category.refinementElements.find((refinement) => refinement.name === value) ?? {}).name
              ?.replace(/&deg;/g, '°')
              ?.replace(/&ge;/g, '≥')
        );
        const currentFilter = `${displayName}:${childNames.join(',')}`;
        filterName += index === 0 ? currentFilter : `|${currentFilter}`;
      }
    });
    return filterName;
  } catch (e) {
    console.log('error in searchFilterTracking', e);
  }
}
export function getFileNameFromUrl(downloadUrl, skuNumber) {
  try {
    const url = new URL(downloadUrl);
    const isPdf = url.pathname.endsWith('.pdf');
    let fileName;
    if (isPdf) {
      const fileNamePdf = url.pathname.split('/').pop();
      fileName = fileNamePdf.split('.')[0];
    } else {
      fileName = skuNumber;
    }
    return fileName;
  } catch (e) {
    console.log('error in getFileNameFromUrl', e);
  }
}
